import { useContext, useEffect, useState } from "react";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/BillingAccounts/BillingAccounts.css";
import BillingAccount from "./BillingAccount";
import { AppContext } from "../../../AppProvider";
import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";

const BillingAccounts = () =>{
    const {user,setSelectedComponent,logout} = useContext(AppContext);
    const[billingAccounts,setBillingAccounts] = useState([]);
    const[showCustomerBillingAccount,setShowCustomerBillingAccount] = useState(false);
    const[customerBillingAccountId,setCustomerBillingAccountId] = useState(false);
    const fetchBillingAccounts = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setBillingAccounts(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when processing the request: ${error}`)
        }
    };
    useEffect(() =>{
        fetchBillingAccounts();
    },[]);
    return(
        <div className="tenant-administrator-billing-accounts-page">
            <NavigationBar/>
            <div className="tenant-administrator-billing-accounts-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-administrator-billing-accounts-parent-container">
                    <div className="tenant-administrator-billing-accounts-container">
                        <div className="tenant-administrator-billing-accounts-header-container">
                            <h2>Customer billing accounts</h2>
                        </div>
                        <div className="tenant-administrator-billing-accounts-body-container">
                            {billingAccounts && billingAccounts.length > 0?
                            (
                                <table>
                                    <thead>
                                        <tr id="tenant-administrator-billing-accounts-table-header-row">
                                            <th>Account Number</th>
                                            <th>Date created</th>
                                            <th>Time created</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {billingAccounts.length > 0 && billingAccounts.map(billingAccount => (
                                            <tr key={billingAccount.accountId} onClick={() =>{
                                                setCustomerBillingAccountId(billingAccount.accountId);
                                                setShowCustomerBillingAccount(true);
                                            }}>
                                                <td>{billingAccount?.accountNumber}</td>
                                                <td>{billingAccount?.dateCreated}</td>
                                                <td>{billingAccount?.timeCreated}</td>
                                                <td>KES {Number(billingAccount.balance).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ):(
                                <div className="tenant-administrator-loading-billing-accounts-mask-container">
                                    <div className="tenant-administrator-loading-billing-accounts-mask">
                                        <div className="tenant-administrator-loading-billing-accounts-mask-spinner"></div>
                                        <p>Loading billing accounts...</p>
                                    </div>
                                </div>
                            )}
                            
                        </div>
                        <BillingAccount
                            user={user}
                            logout={logout}
                            showCustomerBillingAccount={showCustomerBillingAccount}
                            setShowCustomerBillingAccount={setShowCustomerBillingAccount}
                            customerBillingAccountId={customerBillingAccountId}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default BillingAccounts;